import './index.css';
import { Link } from 'react-router-dom';
import ServicesSubMenu from '../ServicesSubMenu';

const rates = [
  { service: 'Cloud Support', rate: '$125/hr' },
  { service: 'Software Development', rate: '$150/hr' },
  { service: 'Cloud Architecture', rate: '$175/hr' },
  { service: 'AI Architecture and Consulting', rate: '$175-$200/hr' },
  { service: 'Emergency or After-hours Support', rate: '$225/hr' },
  { service: 'Micro-controller and Electronics', rate: '$150/hr' },
  { service: 'Tutoring', rate: '$50/hr' },
];

const pricingNotes = [
  'Simple fixed-price projects may still be available when the scope is clear.',
  'Third-party costs such as domains, hosting, SMS, APIs, app store fees, subscriptions, and payment processing are separate unless included in a written estimate.',
  'Emergency and after-hours support is priced higher because it interrupts normal scheduling outside 8:00 AM to 4:00 PM Central Time.',
  'If a service overlaps categories, Hogcloud will confirm the expected rate before work begins.',
];

const Pricing = () => (
  <div className="pricing-page">
    <ServicesSubMenu />

    <section className="pricing-hero">
      <p className="pricing-kicker">Hogcloud Pricing</p>
      <h1>Rates for practical technology help</h1>
      <p>
        Hogcloud is owned by Matt Chandler, a Fayetteville, Arkansas software
        architect and engineer with more than 25 years of experience in software
        services, AWS cloud architecture, full-stack development, business systems,
        AI solutions, electronics, and maker education.
      </p>
      <p>
        Matt&apos;s credentials include AWS Certified Developer - Associate, AWS
        Certified Solutions Architect - Associate, and AWS Academy Cloud Foundations.
      </p>
    </section>

    <section className="pricing-section" aria-labelledby="pricing-rates-title">
      <div className="pricing-section-header">
        <p className="pricing-kicker">Hourly Rates</p>
        <h2 id="pricing-rates-title">Service rates</h2>
      </div>

      <div className="pricing-table-wrap">
        <table className="pricing-rate-table">
          <thead>
            <tr>
              <th scope="col">Service</th>
              <th scope="col">Rate</th>
            </tr>
          </thead>
          <tbody>
            {rates.map((rate) => (
              <tr key={rate.service}>
                <th scope="row">{rate.service}</th>
                <td>{rate.rate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>

    <section className="pricing-retainers" aria-labelledby="pricing-retainers-title">
      <div>
        <p className="pricing-kicker">Ongoing Support</p>
        <h2 id="pricing-retainers-title">Retainers start at $400-$800/month</h2>
        <p>
          Retainers are available for customers who need predictable ongoing help
          with updates, support, cloud guidance, chatbot documents, website changes,
          technical planning, or small recurring tasks.
        </p>
      </div>
      <Link className="pricing-primary-link" to="/contact">Ask About a Retainer</Link>
    </section>

    <section className="pricing-section" aria-labelledby="pricing-notes-title">
      <div className="pricing-section-header">
        <p className="pricing-kicker">What to Expect</p>
        <h2 id="pricing-notes-title">Pricing notes</h2>
      </div>

      <div className="pricing-note-grid">
        {pricingNotes.map((note) => (
          <article key={note}>
            <p>{note}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="pricing-contact" aria-labelledby="pricing-contact-title">
      <h2 id="pricing-contact-title">Ready to scope the work?</h2>
      <p>
        Send a short description of the project, timeline, budget range if known,
        and any examples or account details that help Hogcloud estimate accurately.
      </p>
      <Link className="pricing-primary-link" to="/contact">Contact Hogcloud</Link>
    </section>
  </div>
);

export default Pricing;
